/**
 * see test cards: https://docs.stripe.com/testing#cards
 */


import preact, { h, Fragment } from 'preact'; /** @jsx h */
import { useState, useEffect } from 'preact/hooks';

import { clsx } from 'clsx';
import { ROUTES } from '@pyqml/shared';
import { Session } from '@pyqml/model';
import { PYQML } from '@pyqml/core';
import { Layout } from '../components/Layout';
import { Subheader } from '../components/Subheader';
import { Price } from '../components/Price';

import BlogCover from '../assets/blog-cover.webp';
import { useAuth } from '../app/AuthProvider';
import { PayModeSelect } from '../glue/PayModeSelect';

declare let window: any;

//const RecommendedArticles = lazy(() => import('../glue/RecommendedArticles'));

//    {pages.map(page => <li><a href={`/${page.pageSlug}`}>{page.title}</a></li>)}


const Feature = ({text, bold = false}) => (
    <li>
        {/*<span className="iconsmall" style={{marginRight: "0.5em"}}><i className="fas fa-check"></i></span>*/}
        {
            bold ? <b>{text}</b> : text
        }
    </li>
);


const PaymentModal = ({onClose, level, payMode}) => {
    
    //const { cacheableQuery, cacheablePromise } = useCacheableQueryProvider();
    const { authPromise } = useAuth();


    // we import the lib in the HTML head
    // @ts-ignore
    const stripe = Stripe(typeof window ? window?.__STRIPE_KEY__ : "", {
        apiVersion: '2020-08-27',
    });

    
    useEffect(() => {
        const checkout = stripe.initEmbeddedCheckout({
            fetchClientSecret: () => new Promise((resolve, reject) => {
                authPromise?.({
                    method: "POST",
                    endpoint: ROUTES.CLOUDAPI_PUBLIC_CREATE_CHECKOUT_SESSION,
                    queryData: {
                        level,
                        payMode
                    }
                }).then(response => {
                    resolve(response.data.clientSecret)
                }) ?? reject("No cacheablePromise")
            }),
        }).then(embeddedCheckout => {
            console.log("mounting checkout", embeddedCheckout)
            // Mount Checkout
            embeddedCheckout.mount('#checkout');
            return embeddedCheckout;
        });

        console.log("checkout", checkout);

        return () => {
            console.log("unmounting checkout", checkout)
            checkout.then(c => c.destroy());
        }


    }, []);


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const modal = document.querySelector('.modal-dialog');
            if (modal && !modal.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (

        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ overflowY: "auto", maxHeight: "calc(100vh - 210px)" }}>
                <div className={`modal-header border-0 bg-${level}`}>
                    <h5 className="font-weight-bold" style={{ marginBottom: 0, fontFamily: "ShadowsIntoLight"}}>Become a {level.charAt(0).toUpperCase() + level.slice(1)}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => onClose()}>
                    <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="pb-4 pr-4 pl-4 text-center">
                    <div id="checkout">
                        {/*<!-- Checkout will insert the payment form here -->*/}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export const Subscribe = (props) => {
    
    const [showModal, setShowModal] = useState<'student' | 'practitioner' | 'researcher' | undefined>(undefined);


    console.log("Subscribe", props)

    return <PayModeSelect>{
        (Selector, payMode) => (
        <Fragment>
            { showModal &&
                <div
                    style={{
                        position: "fixed",
                        color: "white",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        zIndex: 1000
                        }}>
                    <PaymentModal onClose={()=>setShowModal(undefined)} level={showModal} payMode={payMode}/>
                </div>        
            }

            <div style={{
                backgroundImage: `url(${BlogCover})`,
                backgroundSize: "cover",
                margin: 0,
                color: "white",
                padding: "80px 0",
                textAlign: "center",
            }}>
                <span style={{
                    display: "block",
                    fontFamily: "ShadowsIntoLight",
                    fontSize: "3em",
                    margin: 0,
                    padding: "8px",
                    lineHeight: "1.1",
                    fontWeight: "bold",
                }}>Hands-On Quantum Machine Learning With Python</span>
                <span style={{
                    fontSize: "1.3em",
                    margin: 0,
                    opacity: 0.8,
                }}>Become an expert in using quantum computing for machine learning</span>
        
            </div>
            <Layout.Stacked>
            
            <Layout.Section weight="equal">
                
                <div weight="top">
                    <Subheader title="Learn Quantum Machine Learning" />
                    <p>
                        Whether you just get started with quantum computing and machine learning or you're
                        already a senior machine learning engineer, <b>Hands-On Quantum Machine Learning With Python</b>
                        is your comprehensive guide to get started with <b>Quantum Machine Learning</b> - the use of
                        quantum computing for the computation of machine learning algorithms.
                    </p>
                    <Selector />
                </div>

                <Layout.Column>
                    <Subheader icon="fab fa-leanpub" iconColor="student" title="Student" tight  />
                    <Price payMode={payMode} year={PYQML.PLANS["student"]["year"]["pricePerMonth"]} month={PYQML.PLANS["student"]["month"]["pricePerMonth"]}/>
                    
                    <ul className="features">
                        <Feature bold text="Early Access eBook Volume 1: Getting Started (Second Edition)" />
                        <Feature text="Complete Online Glossary" />
                        <Feature text="Online Blog (Student-section)" />
                        <Feature text="Tutorial (Student-section)" />
                        <Feature text="Email bulletin" />
                        
                        { payMode === "year" && <Feature bold text="Hands-On Quantum Machine Learning With Python Volume 1: Getting Started (First Edition) eBook" />}
                    </ul>

                    <p className="btn-cta">
                        <a href="#" className="btn btn-student" onClick={() => setShowModal('student')}>Become A Student</a>
                    </p>
                    

                </Layout.Column>
                <Layout.Column>
                    <Subheader icon="fas fa-user-astronaut" iconColor="practitioner" title="Practitioner" tight />
                    <Price payMode={payMode} year={PYQML.PLANS["practitioner"]["year"]["pricePerMonth"]} month={PYQML.PLANS["practitioner"]["month"]["pricePerMonth"]}/>
                    
                    <ul className="features">
                        <Feature text="... Everything from Student" />
                        <Feature bold text="Early Access eBook Volume 2: Real World Applications (Second Edition)" />
                        <Feature text="Online Blog (Practitioner-section)" />
                        <Feature text="Tutorial (Practitioner-section)" />
                        
                        { payMode === "year" && <Feature bold text="Hands-On Quantum Machine Learning With Python Volumes 1 and 2 (First Edition) eBooks" />}
                    </ul>

                    <p className="btn-cta">
                        <a href="#" className="btn btn-practitioner" onClick={() => setShowModal('practitioner')}>Become A Practitioner</a>
                    </p>

                </Layout.Column>
                <Layout.Column>
                    
                    <Subheader icon="fas fa-flask" iconColor="researcher" title="Researcher" tight />
                    <Price payMode={payMode} year={PYQML.PLANS["researcher"]["year"]["pricePerMonth"]} month={PYQML.PLANS["researcher"]["month"]["pricePerMonth"]}/>

                    <ul className="features">
                        <Feature text="... Everything from Practitioner" />
                        <Feature bold text="Early Access eBook Volume 3: Predicting The Future" />
                        <Feature bold text="Early Access eBook Volume 4: Toward Artificial General Intelligence" />
                        <Feature text="Online Blog (Researcher-section)" />
                        <Feature text="Tutorial (Researcher-section)" />
                        { payMode === "year" && <Feature bold text="Hands-On Quantum Machine Learning With Python Volumes 1 and 2 (First Edition) eBooks" />}
                    </ul>

                    <p className="btn-cta">
                        <a href="#" className="btn btn-researcher"onClick={() => setShowModal('researcher')}>Become A Researcher</a>
                    </p>

                </Layout.Column>
                    
                </Layout.Section>
            </Layout.Stacked>
        </Fragment>
    )}</PayModeSelect>
            
}
  
